@use '../../../styles/colors' as *;
@use '../../../styles/variables' as *;
@use '../../../styles/typography' as *;

.text-input-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // 8px gap between the input and its error message (kept in sync with the
  // error-slot reserve in Onboarding/index.scss so the page doesn't shift).
  gap: 8px;
  width: 100%;
}

// Single-line text input — Figma "Text field" component (Size S, 56px tall).
.text-input {
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid $divider-grey-light;
  border-radius: $radius-md;
  background: $bg-white;
  color: $text-primary;
  font-family: $font-inter;
  font-size: $font-size-sm;
  font-weight: $font-weight-regular;
  line-height: $line-height-md;
  outline: none;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: $text-mask;
  }

  &:hover:not(:disabled):not(:focus) {
    border-color: $divider-grey-dark;
  }

  &:focus {
    border-color: $text-primary;
  }

  &:disabled {
    background: $bg-grey;
    color: $text-mask;
    cursor: not-allowed;
  }

  // Error state keeps the red border through hover/focus.
  &--error,
  &--error:hover,
  &--error:focus {
    border-color: $bg-danger;
  }
}

.text-input__error {
  font-family: $font-inter;
  font-size: $font-size-xs;
  line-height: $line-height-sm;
  font-weight: $font-weight-regular;
  color: $bg-danger;
  text-align: left;
}
